import { emitter, TWarningModalProps } from "@shared/modules/core";
import { root } from "@shared/utils";
import React, { useEffect, useState, useCallback } from "react";
import { useIntl } from "react-intl";
import Modal from "react-modal";

export const WarningModal = () => {
  const intl = useIntl();
  const [isOpened, setIsOpened] = useState(false);
  const [params, setParams] = useState<TWarningModalProps | null>(null);

  useEffect(() => {
    const subscription = emitter.on(
      "OPEN_WARNING_MODAL",
      (payload: TWarningModalProps) => {
        setIsOpened(true);
        setParams(payload);
      }
    );

    return () => subscription();
  }, []);

  const handleCloseModal = useCallback(() => setIsOpened(false), []);

  const handleGameStart = useCallback(() => {
    params?.handleSessionStart();
    setIsOpened(false);
    handleCloseModal();
  }, [handleCloseModal, params]);

  const formattedTitle = intl
    .formatMessage({
      id: "please note",
    })
    .toUpperCase();

  const modalBodyText = intl.formatMessage({
    id: "warningModal.bodyText",
    defaultMessage:
      "When you switch to the game, your entire balance will be transferred to the game. This is a feature of this game provider.",
  });

  const modalNoteText = intl.formatMessage({
    id: "warningModal.noteText",
    defaultMessage:
      "There may be a situation where the balance in the system and in the game is different. To return the balance from the game to the system, click EXIT (cross) on the game screen.",
  });

  const okButtonText = intl.formatMessage({
    id: "boilerplate.components.JackpotModal.TimePassed.OkButton",
    defaultMessage: "OK",
  });

  return (
    <Modal
      isOpen={isOpened}
      contentLabel="Warning Modal"
      overlayClassName="contacts-modal__overlay"
      className="contacts-modal__content"
      appElement={root as HTMLElement}
    >
      <div className="contacts-modal__title">
        <svg
          viewBox="0 0 43 40"
          width="1.0625em"
          height="1em"
          className="text-[2.5rem] shrink-0"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M21.46 11.01a2.5 2.5 0 0 0-2.5 2.5c0 1.4.7 8.93.83 11.44 0 .97.7 1.67 1.67 1.67.98 0 1.68-.7 1.68-1.67.27-2.37.83-9.76.83-11.43a2.5 2.5 0 0 0-2.5-2.5Zm0 18.4a2.2 2.2 0 0 0-2.23 2.23 2.2 2.2 0 0 0 2.23 2.23 2.2 2.2 0 0 0 2.23-2.23 2.2 2.2 0 0 0-2.23-2.23Zm20.63 1.25C40.98 28.85 27.32 4.04 26.76 3.21A5.94 5.94 0 0 0 21.46 0a5.94 5.94 0 0 0-5.3 3.2C15.62 4.05 1.82 28.86.85 30.67A6.22 6.22 0 0 0 6.14 40h30.65a6.22 6.22 0 0 0 5.3-9.34Zm-5.16 5.02H6c-.97 0-1.8-.84-1.8-1.81 0-.42 0-.7.27-.98.28-.56 15.33-27.32 15.47-27.6.28-.7.84-1.1 1.53-1.1.7 0 1.26.4 1.68.97.14.28 15.05 27.04 15.47 27.6.14.27.27.55.27.97-.13 1.11-.97 1.95-1.95 1.95Z" />
        </svg>
        <div>{formattedTitle}</div>
      </div>
      <div className="p-4 text-[#474f51]">
        <p
          className="text-[1.125rem] text-bold"
          style={{
            fontWeight: 700,
          }}
        >
          {modalBodyText}
        </p>
        <p className="pt-2 text-[1.125rem]">{modalNoteText}</p>
      </div>
      <button
        className="contacts-modal__button btn btn--secondary btn--lg object__btn"
        onClick={handleGameStart}
      >
        {okButtonText}
      </button>
    </Modal>
  );
};
